import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { AccountManagerDelegate } from "./account.manager.delegate";
import { IAccountManager, INewAccountManager, IManager, IAccountManagerResponse } from "./account.manager.interface";
import { AuthenticationService } from "../AuthenticationService";

export class AccountManagerService
{
    public accountManagerData: IAccountManager[] = null;
    private accountSubject: BehaviorSubject<IAccountManager[]> = new BehaviorSubject(null);
    public accounts: Observable<IAccountManager[]> = this.accountSubject;


    public managerData: IManager = null;
    private managerSubject: BehaviorSubject<IManager> = new BehaviorSubject(null);
    public mangerInfo: Observable<IManager> = this.managerSubject;
    
    private selectedAccountManagerIdd: string = "0";


    public managerInfo: IManager = null;
    private managerInfoSubject: BehaviorSubject<IManager> = new BehaviorSubject(null);
    public manager: Observable<IManager> = this.managerInfoSubject;

    constructor(private accoutnDelegates: AccountManagerDelegate,
        private authenticationService: AuthenticationService)
    {
    }

    public get accountManagerId(): string
    {
        return this.selectedAccountManagerIdd;
    }

    public setselectedSalesRepId(accountManagerId: string): void
    {
        this.selectedAccountManagerIdd = accountManagerId;
    }


    public getSelectedAccountManager(): IAccountManager
    {
        return this.accountManagerData.find(accountManager => accountManager.accountManagerId === this.accountManagerId);
    }

    public getAllAccountManager(hardReload: boolean = false)
    {
        if (this.accountManagerData !== null && this.accountManagerData.length > 0 && hardReload === false)
        {
            return;
        }
        const orgId = this.authenticationService.GetOrgId();

        const response = this.accoutnDelegates.getAllAccManagerByOrgId(orgId);
        return this.processAccountManagers(response);
    }

    public getAccountManagerRepById(accountManagerId: string = ''): Observable<boolean>
    {
        if (accountManagerId === "0")
        {
            this.managerInfo = null;
            this.managerInfoSubject.next(this.managerInfo);
            return observableOf(false);
        }
        const response = this.accoutnDelegates.getAllAccManagerById(accountManagerId);
        return this.processAccountManager(response);
    }
     

    public updateAccountManager(accountManager: IAccountManager): Observable<boolean>
    {
        const response = this.accoutnDelegates.updateManager({ ...accountManager, ...this.authenticationService.getBaseRequest });
        return this.processAccountManagers(response, false);
    }


    public createNewAccountManager(accountManager: INewAccountManager): Observable<boolean>
    {
        const response = this.accoutnDelegates.createNewManager({ ...accountManager, ...this.authenticationService.getBaseRequest });
        return this.processAccountManagers(response, false);
    }

    private processAccountManager(managerData: Observable<IAccountManagerResponse>): Observable<boolean>
    {
        managerData.subscribe(onSuccess.bind(this), onFault.bind(this));

        return managerData.pipe(mergeMap((response: IAccountManagerResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(salesRepResponse: IAccountManagerResponse)
        {
            if (salesRepResponse.success)
            {
                this.managerInfo = salesRepResponse.accountManager;
                this.selectedAccountManagerIdd = salesRepResponse.accountManagerId;
                this.managerInfoSubject.next(this.managerInfo);
            }
        }

        function onFault(error: any)
        {
            //SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }
    private processAccountManagers(managerData: Observable<IManager>, update: boolean = true): Observable<boolean>
    {
        managerData.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return managerData.pipe(mergeMap((response: any) => !response ? observableOf(false) : observableOf(true)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(managerData: IManager)
        {
            if (update)
            {
                if (managerData.accountManagers && managerData.hrManagers && managerData.supervisors)
                {
                    this.managerData = managerData;
                    this.managerSubject.next(this.managerData);

                    this.selectedAccountManagerIdd = managerData.accountManagerId ? managerData.accountManagerId : this.selectedAccountManagerIdd;
                    this.accountManagerData = managerData.accountManagers;
                    this.accountSubject.next(this.accountManagerData);
                }
                else if (managerData.accountManagers)
                {
                    this.accountManagerData = managerData.accountManagers;
                    this.accountSubject.next(this.accountManagerData);

                }

            }
        }

        function onAccountManagersFault(error: any)
        {
            //AccountManagerService.logger.error(`processAccountManagers Fault - Error (${JSON.stringify(error)})`);
        }
    }
}